<ion-app>
  <ion-router-outlet
    [ngClass]="{ 'safe-area': isSafe, 'is-android': isAndroid }"
  ></ion-router-outlet>
  <currency-change></currency-change>

  <ion-fab
    vertical="bottom"
    horizontal="end"
    slot="fixed"
    class="chat_floating_button"
    color="primary"
    (mousedown)="onDragStart($event)"
    (mousemove)="onDrag($event)"
    (mouseup)="onDragEnd($event)"
    (touchstart)="onDragStart($event)"
    (touchmove)="onDrag($event)"
    (touchend)="onDragEnd($event)"
    *ngIf="onLogin"
  >
    <ion-fab-button>
      <ion-icon name="chevron-up-circle-outline" class="text-light"></ion-icon>
    </ion-fab-button>

    <ion-fab-list side="top">
      <ng-container *ngFor="let bookmark of bookmarks">
        <ng-container *ngIf="
          ['instagram_link', 'facebook_link', 'linkedin_link', 'youtube_link', 'twitter_link', 'website_link']
          .includes(bookmark.bookmark_name) &&
          bookmark.bookmark
        ">
          <ion-fab-button color="light" (click)="openLink(bookmark.bookmark)">
            <ion-icon
              [name]="
                bookmark.bookmark_name === 'instagram_link'
                  ? 'logo-instagram'
                  : bookmark.bookmark_name === 'facebook_link'
                  ? 'logo-facebook'
                  : bookmark.bookmark_name === 'linkedin_link'
                  ? 'logo-linkedin'
                  : bookmark.bookmark_name === 'youtube_link'
                  ? 'logo-youtube'
                  : bookmark.bookmark_name === 'twitter_link'
                  ? 'logo-twitter'
                  : bookmark.bookmark_name === 'website_link'
                  ? 'earth-outline'
                  : 'link-outline'
              "
            ></ion-icon>
          </ion-fab-button>
        </ng-container>
      </ng-container>

      <!-- Chat button -->
      <ion-fab-button (click)="openChatModal()">
        <ion-icon name="chatbubble-ellipses"></ion-icon>
      </ion-fab-button>
    </ion-fab-list>
  </ion-fab>
</ion-app>
